module.exports = __webpack_public_path__ + "static/img/UG.df62df40.png";